module.exports = __webpack_public_path__ + "static/media/AboutUs_0.5febab30.png";